'use client';

import { useStorageUrl } from '@/hooks/use-storage-url';
import Avvvatars from 'avvvatars-react';

export type BasicUser = {
  email?: string | null;
  name?: string | null;
  image?: string | null;
  imageStorageKey?: string | null;
};

export function UserAvatarDisplay({
  user,
  size = 32,
  className,
}: {
  user: BasicUser | null | undefined;
  size?: number;
  className?: string;
}) {
  // Prefer imageStorageKey (R2) over image (legacy storageId). Both route
  // through the authenticated resolver (never derive a public CDN URL on the
  // client).
  const imageUrl = useStorageUrl(user?.imageStorageKey ?? user?.image ?? null);

  const avatarValue =
    [user?.email, user?.name]
      .map((value) => value?.trim() ?? '')
      .find((value) => value.length > 0) ?? 'user';

  if (imageUrl) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={imageUrl}
        alt={user?.name || user?.email || 'User'}
        width={size}
        height={size}
        className={`inline-block rounded-full object-cover ${className ?? ''}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <span
      className={`relative inline-flex overflow-hidden rounded-full ${className ?? ''}`}
      style={{ width: size, height: size }}
      aria-label={user?.name || user?.email || 'User'}
      role="img"
    >
      <Avvvatars
        value={avatarValue.toLowerCase()}
        style="shape"
        size={size}
        radius={999}
        shadow={false}
      />
    </span>
  );
}
